module.exports = __webpack_public_path__ + "img/wine-advice_grey.fdbb992e.svg";